module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/images/sparks.1906f32e.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/images/sparks.png
// module id = 2546
// module chunks = 11